import React, { useEffect, useState } from 'react';
import { bool, func, string } from 'prop-types';
import classnames from 'classnames';
import { SearchBox } from '../../../../ps-aspect-design';

ReportSearch.propTypes = {
  initialReportsLoaded: bool,
  setTextFilter: func,
  textFilter: string
};

function ReportSearch(props) {
  const { initialReportsLoaded, setTextFilter, textFilter } = props;

  function clearSearch() {
    setTextFilter('');
  }

  function handleSearch() {
    setTextFilter(textFilter);
  }

  function onSearchChange(event) {
    const value = event.target.value;
    setTextFilter(value);
  }

  return (
    <div className={classnames('reports__search', { 'reports__search--disabled': initialReportsLoaded })}>
      <SearchBox
        aria-label="Report Library SearchBox"
        disabled={!initialReportsLoaded}
        id="search-reports"
        onChange={onSearchChange}
        onClear={clearSearch}
        onSearch={handleSearch}
        placeholder="Search by Report Title"
        value={textFilter}
      />
    </div>
  );
}

export default ReportSearch;
